export default __webpack_public_path__ + "static/cc-1-2344948c438b916a5594afd508a8b5e6.png";